import { readStoredCookieConsent } from '@/lib/analytics/trackingConsent'

import type { ConsentState } from './dictionaries'

export function isFeatureEnabled(): boolean {
  return process.env.NEXT_PUBLIC_PRODUCT_ANALYTICS_ENABLED === 'true'
}

// No cookie means the banner decision is still pending (cookie guide §3.1).
export function consentState(): ConsentState {
  const stored = readStoredCookieConsent()
  if (!stored) return 'undecided'
  return stored.analytics === true ? 'granted' : 'denied'
}

// Single decision point for identified product analytics collection.
// Geo-specific collection policies plug in here later.
export function canCollect(): boolean {
  if (typeof window === 'undefined' || !isFeatureEnabled()) {
    return false
  }
  return consentState() === 'granted'
}
